module.exports = __webpack_public_path__ + "img/horizontal_3_5_7005.033717d0.png";